import { render, staticRenderFns } from "./diagnosis-consultation-modal-empty-state.vue?vue&type=template&id=68bc6d7c&scoped=true&"
import script from "./diagnosis-consultation-modal-empty-state.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal-empty-state.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal-empty-state.scss?vue&type=style&index=0&id=68bc6d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc6d7c",
  null
  
)

export default component.exports